import { CheckCircle2, Copy, Gift, Twitter, MessageCircle, Mail } from "lucide-react";
import { DialogTitle } from "@/components/ui/dialog";

export const PreRegisterSuccess = ({ referralLink, onCopy, onShareTwitter, onShareSMS, onShareEmail }) => (
  <div data-testid="preregister-success" className="text-center py-6">
    <CheckCircle2 size={40} className="text-rr-green mx-auto mb-4" />
    <DialogTitle className="font-heading text-2xl text-rr-navy">You're On The List!</DialogTitle>
    <p className="text-sm text-rr-muted mt-3 leading-relaxed">
      You're on the RelayRigs launch list. We'll let you know when RelayRigs becomes available in your area.
    </p>

    {referralLink && (
      <div data-testid="preregister-referral-box" className="mt-6 bg-rr-surface rounded-2xl border border-rr-line p-5 text-left">
        <div className="flex items-center gap-2 text-rr-navy font-bold text-sm mb-2">
          <Gift size={16} className="text-rr-orange" /> Share your referral link
        </div>
        <p className="text-xs text-rr-muted leading-relaxed mb-3">
          Invite others to pre-register using your link and help build the RelayRigs network in your area.
        </p>
        <div className="flex items-center gap-2">
          <input
            readOnly
            data-testid="preregister-referral-link-input"
            value={referralLink}
            className="flex-1 border border-rr-line rounded-lg px-3 py-2.5 text-xs bg-white text-rr-navy truncate"
          />
          <button
            type="button"
            onClick={onCopy}
            data-testid="preregister-copy-referral-button"
            className="bg-rr-orange text-white rounded-lg px-3 py-2.5 hover:bg-rr-navy transition-colors flex items-center gap-1.5 text-xs font-bold whitespace-nowrap"
          >
            <Copy size={14} /> Copy
          </button>
        </div>

        <div className="flex items-center gap-2 mt-3">
          <button
            type="button"
            onClick={onShareTwitter}
            data-testid="preregister-share-twitter-button"
            className="flex-1 bg-white border border-rr-line rounded-lg px-3 py-2.5 hover:border-rr-orange hover:text-rr-orange transition-colors flex items-center justify-center gap-1.5 text-xs font-bold text-rr-navy"
          >
            <Twitter size={14} /> X
          </button>
          <button
            type="button"
            onClick={onShareSMS}
            data-testid="preregister-share-sms-button"
            className="flex-1 bg-white border border-rr-line rounded-lg px-3 py-2.5 hover:border-rr-orange hover:text-rr-orange transition-colors flex items-center justify-center gap-1.5 text-xs font-bold text-rr-navy"
          >
            <MessageCircle size={14} /> SMS
          </button>
          <button
            type="button"
            onClick={onShareEmail}
            data-testid="preregister-share-email-button"
            className="flex-1 bg-white border border-rr-line rounded-lg px-3 py-2.5 hover:border-rr-orange hover:text-rr-orange transition-colors flex items-center justify-center gap-1.5 text-xs font-bold text-rr-navy"
          >
            <Mail size={14} /> Email
          </button>
        </div>
      </div>
    )}
  </div>
);
